<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8 text-center">
          Contacto
        </h1>
        <div class="prose prose-lg max-w-none">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿Cómo contactar con Soleando?
            </h2>
            <p class="text-base-content/80 mb-4">
              Si deseas ponerte en contacto con nosotros para cualquier
              consulta, sugerencia o colaboración, puedes hacerlo a través de
              los siguientes medios:
            </p>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80 mb-2">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                Dirección: C/ Arturo Soria, 333 – 28033 Madrid, España
              </p>
              <p class="text-base-content/80 mb-2">
                Teléfonos: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Email:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
          </section>
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              Horario de atención
            </h2>
            <p class="text-base-content/80 mb-4">
              Lunes a viernes: 9:00 - 18:00<br />
              Sábados, domingos y festivos: cerrado
            </p>
          </section>
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              Redes sociales
            </h2>
            <p class="text-base-content/80 mb-4">
              Síguenos en nuestras redes sociales para estar al día de novedades
              y experiencias:
            </p>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li>
                <span class="font-semibold">Instagram:</span>
                <a href="#" class="text-primary hover:underline"
                  >@soleando.eu</a
                >
              </li>
              <li>
                <span class="font-semibold">Facebook:</span>
                <a href="#" class="text-primary hover:underline"
                  >facebook.com/soleando.eu</a
                >
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Contacto - Soleando",
  description:
    "Información de contacto de Soleando: dirección, teléfono, email y redes sociales.",
});
</script>

<style scoped></style>
